import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    top: Number,
  };

  static classes = ["sticked"]

  initialize() {

  }

  connect() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.element.classList.remove(...this.stickedClasses)
        } else {
          this.element.classList.add(...this.stickedClasses)
        }
      },
      {
        threshold: 1,
      }
    )

    // 创建一个观察点元素
    this.sentinel = document.createElement("div")
    this.element.parentElement.insertBefore(this.sentinel, this.element)

    this.observer.observe(this.sentinel)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
